import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UnfoldLessDoubleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"unfold_less_double"}/>
}
